module.exports = __webpack_public_path__ + "static/img/38.e4203406.jpeg";